import { useContext, useEffect, useState, useMemo } from "react";
import { allMenu, TMenu } from "../../../../../app/pages/homepage/listMenu";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { checkMenuByPermissions } from "../../../../../app/modules/utils/functionUtils";
import { SidebarMenuWithSub } from "./SidebarMenuWithSub";
import useMultiLanguage from "../../../../../app/hook/useMultiLanguage";
import { SidebarContext } from "../SidebarContext";
import { KEY_LOCALSTORAGE } from "../../../../../app/modules/auth/core/_consts";

export interface IDataMenu {
  isToggleOn?: boolean;
  widthMenu: number;
}

const SidebarMenuMain = () => {
  const { lang } = useMultiLanguage();
  const [isTabletOrMobile, setIsTabletOrMobile] = useState(document.body.offsetWidth <= 992);
  const listMenuSelect = localStorage.getItem(KEY_LOCALSTORAGE?.LIST_SUB_MENU);

  useEffect(() => {
    const handleWindowResize = () => {
      setIsTabletOrMobile(document.body.offsetWidth <= 992);
    }
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const listMenuParentSelect: TMenu[] = useMemo(() => {
    return isTabletOrMobile ? checkMenuByPermissions(allMenu) : [];
  }, [isTabletOrMobile]);

  const [listMenuItem, setListMenuItem] = useState<TMenu[]>([]);
  const [listMenuParent, setListMenuParent] = useState<TMenu[]>([]);

  const [data, setData] = useState<IDataMenu>({} as IDataMenu);
  const { isToggleOn } = useContext(SidebarContext);

  useEffect(() => {
    if (listMenuSelect) {
      setListMenuItem(JSON.parse(listMenuSelect));
    } else {
      const checkedMenu = checkMenuByPermissions(allMenu);
      setListMenuItem(checkedMenu[0].subs || []);
    }
  }, [listMenuSelect])

  useEffect(() => {
    setListMenuParent(listMenuParentSelect);
  }, [listMenuParentSelect])

  useEffect(() => {
    setTimeout(() => {
      setData({
        isToggleOn: isToggleOn,
        widthMenu: document.getElementById('kt_app_sidebar')?.offsetWidth || 0
      })
    }, 300)
  }, [isToggleOn])

  return (<>
    {
      isTabletOrMobile ?
        listMenuParent.map((menu: TMenu, index: number) => (
          <SidebarMenuWithSub
            key={index}
            to={menu.path}
            title={lang(menu?.name)}
            icon={menu.icon}
            subs={menu.subs || []}
          >
            {menu?.subs?.map((menuItem: TMenu, index: number) => (
              <SidebarMenuItem
                data={data}
                key={index}
                to={menuItem.path}
                title={lang(menuItem?.name)}
                hasBullet={menuItem.hasBullet}
                icon={menuItem.icon}
                menuItem={menuItem}
              />
            ))}
          </SidebarMenuWithSub>
        ))
        : listMenuItem.map((menuItem: TMenu, index: number) => (
          <SidebarMenuItem
            data={data}
            key={index}
            to={menuItem.path}
            title={lang(menuItem?.name)}
            hasBullet={menuItem.hasBullet}
            icon={menuItem.icon}
            menuItem={menuItem}
          />
        ))
    }
  </>)
};

export { SidebarMenuMain };

